import { Alert, Button, Card, Form, Input, Table } from 'antd';
import { useSaSmsErrorText, useSaSmsGet } from 'hooks/use-sa-sms-api';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type ConsentEvent = {
    id?: string;
    type?: string;
    channel?: string;
    source?: string;
    createdAt?: string;
    [k: string]: unknown;
};

/** Consent events of one phone (full E.164 typed by the admin; results show whatever marketing-api returns). */
export const SmsConsentLookup: React.FC<{ tenantId: string }> = ({ tenantId }) => {
    const { t, i18n } = useTranslation(['sa-sms']);
    const errorText = useSaSmsErrorText();
    const [phone, setPhone] = useState<string>();
    const { data, isLoading, isError, error } = useSaSmsGet<ConsentEvent[]>(
        `/tenants/${tenantId}/consent-events`,
        { phone },
        !!phone,
    );
    return (
        <Card title={t('activity.consent')}>
            <Form
                layout="inline"
                onFinish={(v: { phone: string }) => setPhone(v.phone.trim())}
                style={{ marginBottom: 16 }}
            >
                <Form.Item
                    name="phone"
                    rules={[
                        { required: true },
                        { pattern: /^\+[1-9]\d{7,14}$/, message: t('activity.phoneFormat') },
                    ]}
                >
                    <Input placeholder="+15551234567" style={{ width: 220 }} />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t('activity.lookup')}
                    </Button>
                </Form.Item>
            </Form>
            {isError && <Alert type="error" showIcon message={errorText(error)} />}
            {phone && !isError && (
                <Table<ConsentEvent>
                    rowKey={(r, i) => r.id ?? String(i)}
                    size="small"
                    loading={isLoading}
                    dataSource={data ?? []}
                    pagination={false}
                >
                    <Table.Column<ConsentEvent>
                        title={t('credits.date')}
                        render={(_, r) =>
                            r.createdAt ? new Date(r.createdAt).toLocaleString(i18n.language) : '-'
                        }
                    />
                    <Table.Column<ConsentEvent> title={t('credits.type')} dataIndex="type" />
                    <Table.Column<ConsentEvent>
                        title={t('activity.source')}
                        render={(_, r) => r.source ?? r.channel ?? '-'}
                    />
                </Table>
            )}
        </Card>
    );
};
